import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { ViewingRowsDropdownComponent } from '../viewing-rows-dropdown/viewing-rows-dropdown.component';
import { ButtonComponent } from '../../buttons/button/button.component';
import { FilterButtonComponent } from '../../buttons/filter-button/filter-button.component';
import { TableFilterGroup } from '../models/table-filter';
import { ButtonType } from '../../enum/button-type.enum';
import { TableFiltersComponent } from '../filters/table-filters/table-filters.component';
import { MatDialog } from '@angular/material/dialog';
import { DialogUtils } from '../../../utils/dialog-utils';
import { ExportCsvComponent } from '../export-csv/export-csv/export-csv.component';
import { TableColumn } from '../models/table-column';
import { SidePanelService } from '../../../../core';
import { Observable } from 'rxjs';

@Component({
  selector: 'lib-table-options-row',
  imports: [ButtonComponent, ViewingRowsDropdownComponent, FilterButtonComponent],
  templateUrl: './table-options-row.component.html',
  styleUrl: './table-options-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableOptionsRowComponent<T> {
  filtersBadgeCount = input<number>();
  searchesBadgeCount = input<number>();
  pageSizeOptions = input<number[]>([10, 25, 50, 75, 100]);
  tableFilterGroups = input.required<TableFilterGroup[] | null>();
  tableColumns = input.required<TableColumn<T>[] | null>();
  exportCSVDataFn = input<() => Observable<T[]>>();
  hasData = input(true);
  viewingRowCount = output<number>();
  clearSearchesClick = output();

  tableFiltersUpdated = output();
  sidePanelService = inject(SidePanelService);
  dialog = inject(MatDialog);
  protected readonly ButtonType = ButtonType;

  filtersClicked() {
    const sidePanel = this.sidePanelService.open(TableFiltersComponent);
    sidePanel.content.instance.initializeTableFilterGroups(this.tableFilterGroups() ?? []);
    sidePanel.ref.afterClosed().subscribe(updateFilters => {
      if (updateFilters) {
        this.tableFilterGroups()?.forEach(g => {
          g.filters.forEach(f => {
            f.commitUnsavedOptions();
          });
        });
        this.tableFiltersUpdated.emit();
      }
    });
  }

  exportToCSVClicked() {
    const ref = this.dialog.open(ExportCsvComponent<T>, DialogUtils.smallDialogConfig());
    ref.componentInstance.tableColumns.set(this.tableColumns() ?? []);
    ref.componentInstance.exportCSVDataFn.set(this.exportCSVDataFn() ?? null);
  }
}
